import { useState } from 'react';

import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { Box } from 'components/Box';
import { Form, FormSection } from 'components/Form';
import { BodySmall } from 'components/Text/BodySmall';
import { H3 } from 'components/Text/H3';
import { CmsApiSupportContactFormBlockReason } from 'modules/cms/api/types/blocks/CmsApiSupportContactFormBlock';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { postJson } from 'utils/http';
import { resetRecaptcha } from 'utils/recaptcha';

import { CmsSupportContactFormBlockContactForm } from './CmsSupportContactFormBlockContactForm';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormValues = Record<string, any>;

const handleSubmit = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { handleError, updateSubmitting, values }: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blockId: any,
  user: ApiUser,
  setSubmittedValues: (values: FormValues | null | undefined) => void,
) => {
  const { orgs = [] } = user || {};
  const { id: orgId = '' } =
    orgs.find((org) => org.name === values.orgName) || {};
  const valuesToSubmit = {
    orgId,
    ...values,
    attachmentIds: values.attachmentIds.filter(Boolean),
  };
  postJson(`/data/website/support-contact-form/${blockId}`, valuesToSubmit)
    .then(() => {
      updateSubmitting(false);
      setSubmittedValues(valuesToSubmit);
    })
    .catch((e) => {
      resetRecaptcha();
      handleError(e, {
        recaptchaKey: values.recaptchaKey + 1,
        gRecaptchaResponse: undefined,
      });
    });
};

type Props = {
  blockId: string;
  data: {
    reasons: CmsApiSupportContactFormBlockReason[];
  };
};

export function CmsSupportContactFormBlock({ blockId, data }: Props) {
  const { user } = useUserEnvironment();

  const initialValues = {
    email: user?.email,
    firstName: user?.firstName,
    lastName: user?.lastName,
    locale: CURRENT_LOCALE,
    attachmentIds: [''],
  };
  const [submittedValues, setSubmittedValues] = useState<
    FormValues | null | undefined
  >();
  const { reasons } = data;
  const submitedWithReasonFeedback =
    submittedValues && submittedValues.reason === 'FEEDBACK';

  if (submittedValues)
    return (
      <Box m={64} textAlign="center">
        <H3>{getText('Thanks for submitting')}</H3>
        <BodySmall>
          {submitedWithReasonFeedback
            ? getText(
                'We’ll make sure to consider your feedback and will get back to you when we can!',
              )
            : getText('Someone will respond to you shortly.')}
        </BodySmall>
      </Box>
    );

  return (
    <FormSection>
      <Form
        analyticsTitle="[cms] Support contact block"
        usageContext="page"
        data-qa-id="support-contact-form"
        initialValues={
          initialValues as typeof initialValues & {
            reason?: string;
            subReason?: string;
          }
        }
        onSubmit={(formContext) =>
          // @ts-expect-error TS(2345): Argument of type 'ApiUser | undefined' is not assi... Remove this comment to see the full error message
          handleSubmit(formContext, blockId, user, setSubmittedValues)
        }
        render={({ getValue, updateValue }) => {
          const selectedReason = reasons.find(
            (r) => r.id === getValue('reason'),
          );
          const selectedSubReason =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            selectedReason &&
            selectedReason.subReasons &&
            selectedReason.subReasons.find(
              (s) => s.id === getValue('subReason'),
            );
          return (
            <CmsSupportContactFormBlockContactForm
              reasons={reasons}
              selectedReason={selectedReason}
              selectedSubReason={selectedSubReason}
              updateValue={updateValue}
            />
          );
        }}
      />
    </FormSection>
  );
}
